export default "__VITE_ASSET__DJwdcGYT__"